// Sizes an SPASelect to the 2.125rem SPA input control so it lines up in a form row; the select
// theme defaults taller.
const CONTROL_HEIGHT = '2.125rem';

const compactSelectStyles = {
  control: (base: object) => ({ ...base, height: CONTROL_HEIGHT, minHeight: CONTROL_HEIGHT }),
  valueContainer: (base: object) => ({ ...base, padding: '0 0.5rem' }),
};

export default compactSelectStyles;
